var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-link',{staticClass:"page-apps-mobile-navigation-pill",class:{
        'page-apps-mobile-navigation-pill--open': _vm.isActive,
    },attrs:{"to":_vm.getToByCategory(_vm.routeName)}},[_c(_vm.icon,{tag:"component",staticClass:"page-apps-mobile-navigation-pill__icon"}),_vm._v(" "),_c('div',{staticClass:"page-apps-mobile-navigation-pill__text",domProps:{"textContent":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }